import { PapyrusDocument } from "./DocumentModels";
import DocumentRepresentationService from "./DocumentRepresentationService";

export default class DocumentReferenceService {
    static toPapyrusDocument(documentReference: any): PapyrusDocument {
        return {
            id: documentReference.id,
            subject: DocumentReferenceService.getSubject(documentReference),
            type: DocumentReferenceService.getDocumentType(documentReference),
            date: DocumentReferenceService.getDocumentDate(documentReference),
            status: documentReference.status ?? "-",
            representations: DocumentRepresentationService.buildRepresentations(documentReference),
        };
    }

    static getRepresentation(documentReference: any, contentIndex: number) {
        return DocumentRepresentationService.buildRepresentations(documentReference)
            .find((representation) => representation.contentIndex === contentIndex);
    }

    private static getSubject(documentReference: any): string {
        return documentReference.subject?.display ?? documentReference.subject?.reference ?? "-";
    }

    private static getDocumentType(documentReference: any): string {
        const coding = documentReference.type?.coding?.[0];
        return documentReference.type?.text ?? coding?.display ?? coding?.code ?? "-";
    }

    private static getDocumentDate(documentReference: any): string {
        return documentReference.date ?? documentReference.indexed ?? documentReference.meta?.lastUpdated ?? "";
    }
}
